import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 40px;
  align-self: stretch;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 54px;
  gap: 8px;
  flex: 1;
  justify-content: center;
  max-width: 100%;
`;
